import KmsHttpService from '@/servises/kmsHttpService';
import { getV2Endpoint } from '@/utils/apiV2Endpoints';

export default {
    getLanguages: () => {
        return KmsHttpService.get(getV2Endpoint('languages'));
    }
};
